import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { Offer, PaymentInterfaceNew } from '../../../new-lib/types/entity';
import { EntityTypes } from '../../../new-lib/constants/common';

const MobilePaymentPlansPresentation = dynamic(
  () => import('./mobile/MPaymentPlansPresentation')
);
const DesktopPaymentPlansPresentation = dynamic(
  () => import('./PaymentPlansPresentation')
);

interface ChildProps {
  entityType: EntityTypes;
  paymentPlans: PaymentInterfaceNew[];
  showOffers: boolean;
  offers: Offer[];
}

const PaymentPlansContainer = ({
  entityType,
  paymentPlans,
  showOffers,
  offers
}: ChildProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const filterPlan = (plan: PaymentInterfaceNew) => {
    if (plan?.downPaymentPercentage != null && plan?.years != null) {
      return plan;
    } else {
      return;
    }
  };

  const filterOffer = (offer: Offer) => {
    if (
      offer?.cashDiscountPercentage != null ||
      (offer?.downPaymentPercentage != null &&
        offer?.years != null) ||
      offer.discountPercentage != null
    )
      return offer;

    return null;
  };

  const [filteredPlans, setFilteredPlans] = useState<PaymentInterfaceNew[]>(
    paymentPlans.length > 0
      ? paymentPlans.filter((plan: PaymentInterfaceNew) => filterPlan(plan))
      : []
  );
  const [filteredOffers, setFilteredOffers] = useState<Offer[]>(
    showOffers ? offers.filter((offer: Offer) => filterOffer(offer)) : []
  );

  useEffect(() => {
    setFilteredOffers([]);
    setFilteredPlans([]);
    if (paymentPlans.length > 0) {
      let filteredPlans = paymentPlans.filter((plan: PaymentInterfaceNew) =>
        filterPlan(plan)
      );
      if (filteredPlans.length > 0) {
        setFilteredPlans(filteredPlans);
      }
    }

    if (showOffers && offers.length > 0) {
      const filteredOffers = offers.filter((offer: Offer) =>
        filterOffer(offer)
      );

      if (filteredOffers.length > 0) {
        setFilteredOffers(filteredOffers);
      }
    }
  }, [paymentPlans, offers]);

  const getPaymentPlans = () => {
    const plansCount = filteredPlans.length + filteredOffers.length;

    return plansCount > 0 ? (
      isMobile ? (
        <MobilePaymentPlansPresentation
          plans={filteredPlans}
          offers={filteredOffers}
          entityType={entityType}
        />
      ) : (
        <DesktopPaymentPlansPresentation
          plans={filteredPlans}
          offers={filteredOffers}
          entityType={entityType}
        />
      )
    ) : null;
  };

  return <>{getPaymentPlans()}</>;
};
export default PaymentPlansContainer;
